export default "__VITE_ASSET__F$UyzV1S__"